import { ThemeUICSSObject } from 'theme-ui';
/* IMPORT HERE */

const textarea: ThemeUICSSObject = {
  height: '100%',
  minHeight: '130px',
  resize: 'vertical',

  variant: 'forms.input',
};

export default textarea;
